import { PageHeader, RadioCard, ResourceEmptyState } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import { CheckboxGroup } from 'react-aria-components';
import { encodeQueryItem } from 'ufo';
import { getUpsellproductsOptions } from '../../../../features/add-insurance/upsell-products/queryOptions';

import { parseProductsFromQuery } from '../../../../features/add-insurance/utils';

export const Route = createFileRoute(
  '/_authenticated/add-insurance/$customer/_layout/',
)({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { customer: guid } }) =>
    queryClient.ensureQueryData(
      getUpsellproductsOptions({ customerGuid: guid }),
    ),
});

function RouteComponent() {
  const data = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const handleOnProductSelection = useCallback((value: Array<string>) => {
    const query = encodeQueryItem('guid', value);
    navigate({
      search: {
        products: query,
      },
    });
  }, []);

  const selectedProducts = useMemo(
    () => parseProductsFromQuery(search.products),
    [search],
  );

  return (
    <div className="layout-simple">
      <PageHeader
        className="area-page-header"
        title="Selecteer een verzekering"
        backLink={{
          to: '/add-insurance',
        }}
      />
      <div className="area-page-content content-grid">
        <div className="col-span-full">
          {data?.length > 0 ? (
            <CheckboxGroup
              onChange={handleOnProductSelection}
              value={selectedProducts}
            >
              <ul className="flex flex-col gap-y-24">
                {data.map((product) => {
                  const uniqueKey = product.riskPool
                    ? `${product.guid}|${product.riskPool}`
                    : product.guid;
                  const isDisabled = selectedProducts.some((selected) => {
                    const [selectedGuid] = selected.split('|');
                    return (
                      selectedGuid === product.guid && selected !== uniqueKey
                    );
                  });

                  return (
                    <li key={uniqueKey}>
                      <RadioCard
                        isDisabled={isDisabled}
                        value={uniqueKey}
                        name={product.name}
                        icon={product.icon}
                      />
                    </li>
                  );
                })}
              </ul>
            </CheckboxGroup>
          ) : (
            <ResourceEmptyState
              message="Er zijn momenteel geen verzekeringen beschikbaar. Probeer het over 5 minuten opnieuw."
              className="text-center"
            />
          )}
        </div>
      </div>
    </div>
  );
}
